export function isEmpty(obj: Record<string, unknown>) {
    // eslint-disable-next-line guard-for-in
    for (const _i in obj) return false;
    return true;
}
